import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { CallflowCreateDoc } from 'types/callflow';

export const useCreateCallflow = () => {
  const authState = useAuthSelector();
  return useMutation<any, AxiosError, CallflowCreateDoc, unknown>(
    (callflowDoc: CallflowCreateDoc) =>
      sdk.callflow.mutate.create(
        {
          data: callflowDoc,
          // other values such as "accept_charges" could go here
        },
        {
          authToken: authState?.auth_token,
        },
      ),
  );
};
